import axios from "axios";

//const BACKEND_APP_HOST = "http://localhost:3001";
const BACKEND_APP_HOST = process.env.REACT_APP_BACKEND_APP_HOST;

export const fetchAdAccounts = async (accessToken) => {
  try {
	  
	  const response = await axios.post(
      `${BACKEND_APP_HOST}/google/fetch-ad-accounts`,
      {
        accessToken
      }
    ); 
  
   return response;
  } catch (error) {
    console.error("Error fetching Google Ad Accounts:", error);
  }
};


export const setCancelPlan = async (shop) => {
  try {
    const response = await axios.post(
      `${BACKEND_APP_HOST}/shopify/cancelPlan/?shop=${shop}`
    );
    return response;
  } catch (error) {
    console.error("Error returning data:", error);
  }
};

export const getCurrentPlan = async (shop) => {
  try {
    const response = await axios.get(
      `${BACKEND_APP_HOST}/shopify/currentPlan/?shop=${shop}`
    );
    return response;
  } catch (error) {
    console.error("Error returning data:", error);
  }
};



